// extracted by mini-css-extract-plugin
export default {"image":"dD_dx","industry":"dD_my","industryTitle":"dD_mz"};